import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const FolderSelectIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_ddddd_2894_22012)">
        <rect x="2" y="1" width="28" height="28" rx="2" fill={fillColor || 'url(#paint0_linear_2894_22012)'} />
        <rect x="2.5" y="1.5" width="27" height="27" rx="1.5" stroke="url(#paint1_linear_2894_22012)" />
      </g>
      <defs>
        <filter
          id="filter0_ddddd_2894_22012"
          x="0"
          y="0"
          width="47"
          height="47"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2894_22012" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_2894_22012" result="effect2_dropShadow_2894_22012" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="4" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_2894_22012" result="effect3_dropShadow_2894_22012" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="8" dy="8" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="effect3_dropShadow_2894_22012" result="effect4_dropShadow_2894_22012" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="12" dy="13" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
          <feBlend mode="normal" in2="effect4_dropShadow_2894_22012" result="effect5_dropShadow_2894_22012" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect5_dropShadow_2894_22012" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_2894_22012" x1="8.16" y1="1" x2="33.3087" y2="14.6452" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2B2D2F" />
          <stop offset="1" stopColor="#1B1D1E" />
        </linearGradient>
        <linearGradient id="paint1_linear_2894_22012" x1="13.2" y1="15.9655" x2="3.86372" y2="7.78158" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" stopOpacity="0.15" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export { FolderSelectIcon };
